<template>
  <aside class="widget widget-categories" v-if="property">
    <div class="widget-title">
      <h6>{{ t('property_detail.property.features') }}</h6>
    </div>
    <ul>
      <li v-for="item in propertyDetails" :key="item.label">
        <span class="fw-medium text-dark">{{ item.label }}</span>
        <span class="float-right text-muted">{{ item.value }}</span>
      </li>
    </ul>
  </aside>

  <div v-else class="text-center text-gray-500 mt-4">
    {{ t('property_detail.property.loading') }}
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const props = defineProps({
  property: Object
})

const propertyDetails = computed(() => [
  { label: t('property_detail.property.location'), value: props.property.country || t('property_detail.property.unpublished.location') },
  { label: t('property_detail.property.region'), value: props.property.region || t('property_detail.property.not_specified') },
  { label: t('property_detail.property.city'), value: props.property.city || t('property_detail.property.not_specified') },
  { label: t('property_detail.property.district'), value: props.property.district || t('property_detail.property.not_specified') },
  // { label: t('property_detail.property.address'), value: props.property.address || t('property_detail.property.not_specified') },
  { label: t('property_detail.property.residential_complex'), value: props.property.residential_complex || t('property_detail.property.not_specified') },
  // { label: t('property_detail.property.building'), value: props.property.building || t('property_detail.property.not_specified') },
  { label: t('property_detail.property.rooms'), value: props.property.rooms || t('property_detail.property.not_specified') },
  { label: t('property_detail.property.floor'), value: props.property.floor !== null ? props.property.floor : t('property_detail.property.not_specified') },
  { label: t('property_detail.property.total_floors'), value: props.property.total_floors !== null ? props.property.total_floors : t('property_detail.property.not_specified') },
  { label: t('property_detail.property.gross_area'), value: props.property.gross_area ? props.property.gross_area + ' м²' : t('property_detail.property.not_specified') },
  { label: t('property_detail.property.net_area'), value: props.property.net_area ? props.property.net_area + ' м²' : t('property_detail.property.not_specified') },
  { label: t('property_detail.property.year_of_construction'), value: props.property.year_of_construction || t('property_detail.property.not_specified') },
  { label: t('property_detail.property.heating'), value: props.property.heating_label || t('property_detail.property.not_specified') },
  { label: t('property_detail.property.orientation'), value: props.property.orientation_label || t('property_detail.property.not_specified') },
  { label: t('property_detail.property.building_type_label'), value: props.property.building_type_label || props.property.building_type_label || t('property_detail.property.not_specified') },
  { label: t('property_detail.property.view'), value: props.property.view_label || t('property_detail.property.not_specified') }
])
</script>
